import React from "react";
import { motion } from "framer-motion";
import './Animation.css'; // For custom variables and keyframes
import { NavLink } from "react-router-dom";

const Animation = () => {
  return (
    <motion.div
      className="w-100 fade-in"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.6, duration: 0.6 }}
    >
      <div className="position-relative ms-0 ms-md-3 animate-float">
        {/* Card Container */}
        <div className="bg-card shadow rounded-lg p-4 border border-border position-relative">
          
          {/* Floating Icon */}
          <div className="position-absolute top-0 end-0 translate-middle bg-primary text-primary-foreground rounded-circle p-2">
            <svg
              className="bi bi-geo-alt"
              width="20"
              height="20"
              fill="currentColor"
              viewBox="0 0 16 16"
            >
              <path d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"></path>
            </svg>
          </div>

          {/* Colored Dots */}
          <div className="d-flex mb-3">
            <div className="rounded-circle bg-danger me-2" style={{ width: '12px', height: '12px' }}></div>
            <div className="rounded-circle bg-warning me-2" style={{ width: '12px', height: '12px' }}></div>
            <div className="rounded-circle bg-success" style={{ width: '12px', height: '12px' }}></div>
          </div>

          {/* Header */}
          <div className="d-flex align-items-center mb-3">
            <div
              className="d-flex align-items-center justify-content-center rounded bg-primary text-white me-3"
              style={{ width: '32px', height: '32px' }}
            >
              <i className="fas fa-code"></i>
            </div>
            <div>
              <h5 className="mb-0">NetworkBuilder Platform</h5>
              <p className="text-muted mb-0">Realtime Development Collaboration</p>
            </div>
          </div>

          {/* Code Block */}
          <div className="bg-muted rounded-md p-3 mb-3">
            <div className="d-flex justify-content-between mb-2">
              <div className="d-flex align-items-center">
                <div
                  className="rounded-circle bg-accent d-flex align-items-center justify-content-center me-2"
                  style={{ width: '24px', height: '24px' }}
                >
                  <span className="text-accent-foreground fw-bold">JS</span>
                </div>
                <span className="fw-medium">app.js</span>
              </div>
              <div className="text-muted small">Just now</div>
            </div>
            <pre className="bg-background border rounded p-2 text-foreground small">
              {`const animateUI = () => {
  elements.forEach(el => {
    el.classList.add('animated');
  });
  return Promise.resolve();
};`}
            </pre>
          </div>

          {/* Grid */}
          <div className="row g-2 mb-3">
            <div className="col-8">
              <div className="bg-muted rounded" style={{ height: '60px' }}></div>
            </div>
            <div className="col-4">
              <div className="bg-muted rounded" style={{ height: '60px' }}></div>
            </div>
            <div className="col-4">
              <div className="bg-muted rounded" style={{ height: '60px' }}></div>
            </div>
            <div className="col-8">
              <div className="bg-muted rounded" style={{ height: '60px' }}></div>
            </div>
          </div>

          {/* Button */}
          <div className="d-flex justify-content-end">
            <button className="btn btn-primary"><NavLink to={"/contact"} className="text-white fw-bold text-decoration-none">Contact</NavLink></button>
          </div>
        </div>

        {/* Floating Background */}
        <div className="position-absolute bottom-0 end-0 w-100 h-100 bg-gradient-to-br from-accent to-primary rounded-lg opacity-25 blur" style={{ zIndex: -1 }}></div>
      </div>
    </motion.div>
  );
};

export default Animation;
